import { AbstractControl, ValidatorFn } from '@angular/forms';
import patterns from 'utils/patterns';

import {
  lifeCycleStatusLookup, nationalPopularityCodeLookup, uomLookup,
} from 'shared/product/product-lookups';
import { DetailsControlType } from 'shared/details-page/details-control/details-control-type';
import { SegmentFieldItem } from 'utils/segment-field-item.interface';
import { isLookupOption } from 'shared/validation/select-validation';
import { gtinValidation } from 'shared/validation/gtin-validation';


/* eslint-disable */
export const detailsSegmentData:Array<SegmentFieldItem> = [
  {
    'field_map': 'brandLabel',
    'item_name': 'details.brandLabel',
    'title': 'Brand Name',
    'hint_detail': 'Brand name corresponding with Brand ID found in the Auto Care maintained Parent/Supplier/Brand Code Registry',
    'hint_panel' : 'Brand name corresponding with Brand ID found in the Auto Care maintained Parent/Supplier/Brand Code Registry',
    'example': 'Wonderhose',
    'sequence': 1,
    'show_more': true,
    'readonly': true,
    'validation' : {
      'pies65': {
        'required': true,
        'minLength': 1,
        'maxLength': 60,
        'message': 'Brand label is required and must be no more than 60 characters.'
      }
    },
    'lookup': null
  },
  {
    'field_map': 'subBrand',
    'item_name': 'details.subBrand',
    'title': 'SubBrand Name',
    'hint_detail': 'SubBrand name corresponding with SubBrand ID in the Auto Care maintained Parent/Supplier/Brand Code Registry.',
    'hint_panel' : 'SubBrand name corresponding with SubBrand ID in the Auto Care maintained Parent/Supplier/Brand Code Registry.',
    'example': 'ABC AM Products',
    'sequence': 2,
    'show_more': false,
    'lookup': [],
    'api_lookup': {
        'type': 'list',
        'lookup': 'sub-brands',
        'field_map': 'brandId'
    }
  },
  {
    'field_map': 'partNumber',
    'item_name': 'partNumber',
    'title': 'Part Number',
    'hint_detail': 'Manufacturers determined part number',
    'hint_panel' : 'Manufacturers determined part number',
    'example': 'HOS101',
    'sequence': 3,
    'show_more': true,
    'readonly': true,
    'validation': {
      'pies65' : {
        required: true,
        minLength: 1,
        maxLength: 48,
        message: 'Part number is required and must be no more than 48 characters'
      }
    },
    'lookup': null,
    'not_bulk_editable': true,
  },
  {
    'field_map': 'basePartNumber',
    'item_name': 'details.basePartNumber',
    'title': 'Base Part Number',
    'hint_detail': 'Link this to another part number if this part is a configuration or option., like 123-BLK, 123-RED, etc.',
    'hint_panel' : 'Link this to another part number if this part is a configuration or option., like 123-BLK, 123-RED, etc.',
    'example': 'My base part number is HS123, which comes in several color options, like BLK (black), RED (red), etc.',
    'sequence': 4,
    'show_more': false,
    'validation': {
      'pies65' : {
        minLength: 1,
        maxLength: 48,
        pattern: patterns.alphaNumericalDashes,
        message: 'Base part no. cannot be longer than 48 characters.'
      }
    },
    'lookup': null
  },
  {
    'field_map': 'gtin',
    'item_name': 'details.gtin',
    'title': 'GTIN',
    'hint_detail': 'Global Trade Item Number (GTIN) can be used by a company to uniquely identify all of its trade items. The GTIN number can be based on Universal Product Code (UPC) or International Article Number (EAN).',
    'hint_panel' : 'Global Trade Item Number (GTIN) can be used by a company to uniquely identify all of its trade items. The GTIN number can be based on Universal Product Code (UPC) or International Article Number (EAN).',
    'example': '00024844170316',
    'sequence': 5,
    'show_more': true,
    'lookup': null,
    'not_bulk_editable': true,
    'numerical': true,
    'validation' : {
      'pies65': {
        'length': 14,
        'custom': function (): ValidatorFn {
          return gtinValidation();
        },
        'message': 'GTIN must be a valid UPC/EAN code with 14 digits. Please verify the check digit is valid and the digit count is correct.'
      }
    },
  },
  {
    'field_map': 'gtinQualifier',
    'item_name': 'details.gtinQualifier',
    'title': 'UPC/EAN code',
    'hint_detail': 'UPC/EAN : A 12 digit number identifying the manufacturers shipping unit. The code division is 2-5-5. Its qualifier is UA The code is formatted as: 2 digit number system character(U.S. Grocery and General Merchandise=00,06 or 07; US Drug=03)(EAN=2 digit country flag); 5 digit manufacturing identification number; 5 digit item number',
    'hint_panel' : 'UPC/EAN : A 12 digit number identifying the manufacturers shipping unit. The code division is 2-5-5. Its qualifier is UA The code is formatted as: 2 digit number system character(U.S. Grocery and General Merchandise=00,06 or 07; US Drug=03)(EAN=2 digit country flag); 5 digit manufacturing identification number; 5 digit item number',
    'example': 'UPC',
    'sequence': 6,
    'show_more': true,
    'validation': {
      'pies65': {
        'required': true,
        'message': 'UPC/EAN code is required when GTIN is populated.'
      }
    },
    'lookup': [
      {
        'option': '',
        'title': '-'
      },
      {
        'option': 'UP',
        'title': 'UPC'
      },
      {
        'option': 'EN',
        'title': 'EAN'
      }
    ],
    'not_bulk_editable': true,
  },
  {
    'field_map': 'hasFitments',
    'item_name': 'details.hasFitments',
    'title': 'Vehicle fitments',
    'hint_detail': 'YES if this item has vehicle fitments (ACES applications) or NO if this item is universal',
    'hint_panel' : 'Select YES if this item has vehicle fitments (ACES applications) or NO if this item is universal',
    'example': 'Yes',
    'sequence': 7,
    'show_more': true,
    'validation' : {
      'pies65': {
        'minLength': 1,
        'maxLength': 1,
      }
    },
    'lookup': [
      {
        'option': '',
        'title': '-'
      },
      {
        'option': 'Y',
        'title': 'Yes'
      },
      {
        'option': 'N',
        'title': 'No'
      }
    ]
  },
  {
    'field_map': 'emissionCode',
    'item_name': 'details.emissionCode',
    'title': 'Emission code',
    'hint_detail': 'Indicates if this product is legal for use in the U.S. including California, off-road only, or legal for use in U.S. excluding California.',
    'hint_panel' : 'Select if this product is legal for use in the U.S. including California, off-road only, or legal for use in U.S. excluding California.',
    'example': 'Legal in US',
    'sequence': 8,
    'show_more': false,
    'lookup': [
      {
        'option': '1',
        'title': 'CARB Eligible'
      },
      {
        'option': '2',
        'title': 'EPA Eligible'
      },
      {
        'option': '3',
        'title': 'Racing or Pre-emissions use only'
      },
      {
        'option': '4',
        'title': 'Emissions Compliance Exempt'
      },
      {
        'option': '5',
        'title': 'Emissions Status Pending'
      }
    ],
  },
  {
    'field_map': 'hazardousMaterialCode',
    'item_name': 'details.hazardousMaterialCode',
    'title': 'Hazardous Material',
    'hint_detail': 'Yes or No if product contains hazardous material.',
    'hint_panel' : 'Select Yes or No if product contains hazardous material.',
    'example': 'No',
    'sequence': 9,
    'show_more': true,
    'lookup': [
      {
        'option': '',
        'title': '-'
      },
      {
        'option': 'N',
        'title': 'No'
      },
      {
        'option': 'Y',
        'title': 'Yes'
      }
    ]
  },
  {
    'field_map': 'taxable',
    'item_name': 'details.taxable',
    'title': 'Taxable',
    'hint_detail': 'Indicates whether this product is taxable or not.',
    'hint_panel' : 'Select whether this product is taxable or not.',
    'example': 'Yes',
    'sequence': 10,
    'show_more': true,
    'lookup': [
      {
        'option': '',
        'title': '-'
      },
      {
        'option': 'N',
        'title': 'No'
      },
      {
        'option': 'Y',
        'title': 'Yes'
      }
    ]
  },
  {
    'field_map': 'refurbishedPart',
    'item_name': 'details.refurbishedPart',
    'title': 'Refurbished part',
    'hint_detail': 'Indicates whether this item is refurbished or not.',
    'hint_panel' : 'Select whether this item is refurbished or not.',
    'example': 'Yes',
    'sequence': 11,
    'show_more': false,
    'validation' : {
      'pies65': {
        'minLength': 1,
        'maxLength': 1,
        'message': 'Please select YES if this item is refurbished or NO not'
      }
    },
    'lookup': [
      {
        'option': '',
        'title': '-'
      },
      {
        'option' : 'N',
        'title' : 'No'
      },
      {
        'option' : 'Y',
        'title' : 'Yes'
      }
    ]
  },
  {
    'field_map': 'remanufacturedPart',
    'item_name': 'details.remanufacturedPart',
    'title': 'Remanufactured part',
    'hint_detail': 'Indicates whether this item is remanufactured or not.',
    'hint_panel' : 'Select whether this item is remanufactured or not.',
    'example': 'Yes',
    'sequence': 12,
    'show_more': false,
    'validation' : {
      'pies65': {
        'minLength': 1,
        'maxLength': 1,
        'message': 'Please select YES if this item remanufactured or NO if this item is universal'
      }
    },
    'lookup': [
      {
        'option': '',
        'title': '-'
      },
      {
        'option' : 'N',
        'title' : 'No'
      },
      {
        'option' : 'Y',
        'title' : 'Yes'
      }
    ]
  },
  {
    'field_map': 'productCondition',
    'item_name': 'details.productCondition',
    'title': 'Product Condition',
    'hint_detail': 'Product Condition.',
    'hint_panel' : 'Product Condition.',
    'example': 'REF',
    'sequence': 13,
    'show_more': false,
    'lookup': [
      {
        'title': 'Refurbished',
        'option': 'REF',
      },
      {
        'title': 'Remanufactured',
        'option': 'REM',
      },
      {
        'title': 'New',
        'option': 'NEW',
      },
      {
        'title': 'Used',
        'option': 'USE',
      }
    ]
  },
  {
    'field_map': 'lifeCycleStatus',
    'item_name': 'details.lifeCycleStatus',
    'title': 'Life cycle status',
    'hint_detail': 'Indicates this parts current stage in the release cycle.',
    'hint_panel' : 'Select the current stage the part is within.',
    'sequence': 14,
    'show_more': true,
    'lookup': lifeCycleStatusLookup,
    'validation': {
      'pies65' : {
        'custom': function (): ValidatorFn {
          return isLookupOption(lifeCycleStatusLookup);
        },
        message: 'Code doesn\'t exist within the lookup.'
      }
    },
  },
  {
    'field_map': 'nationalPopularityCode',
    'item_name': 'details.nationalPopularityCode',
    'title': 'National popularity (Product Velocity)',
    'hint_detail': 'Indicates the product velocity (i.e., days or weeks a product stays in warehouse inventory before being sold).',
    'hint_panel' : 'Select the appropriate velocity level for the part number.',
    'example': '(B) Next 20% of Product group sales value',
    'sequence': 15,
    'show_more': true,
    'lookup': nationalPopularityCodeLookup,
  },
  {
    'field_map': 'partType',
    'item_name': 'partTerminology.id',
    'title': 'Part ID',
    'hint_detail': 'Part ID, maintained by the Auto Care Association within the Part Classification database (PCdb).',
    'hint_panel' : 'Select the appropriate part ID for this item. Part IDs are maintained by the Auto Care Association within the Part Classification database (PCdb).',
    'example': '12345',
    'sequence': 16,
    'show_more': true,
    'lookup': null,
    'readonly': true,
    // 'api_lookup': {
    //     'type': 'typeahead',
    //     'field_map': 'partType',
    //     'item_name': 'partTerminology.id',
    //     'lookup': 'part-id',
    // }
  },
  {
    'field_map': 'partTypeName',
    'item_name': 'partTerminology.name',
    'title': 'Part type',
    'hint_detail': 'Part type, also known as part terminology, maintained by the Auto Care Association within the Part Classification database (PCdb).',
    'hint_panel' : 'Select the appropriate part type (aka, part terminology) for this item. Part types are maintained by the Auto Care Association within the Part Classification database (PCdb).',
    'example': 'Air Filter',
    'sequence': 17,
    'show_more': true,
    'lookup': null,
    'readonly': true,
    // 'api_lookup': {
    //     'type': 'typeahead',
    //     'field_map': 'partTypeName',
    //     'item_name': 'partTerminology.name',
    //     'lookup': 'part-type',
    // }
  },
  {
    'field_map': 'partCategory',
    'item_name': 'partTerminology.category.name',
    'title': 'Category',
    'hint_detail': 'Category, maintained by the Auto Care Association within the Part Classification database (PCdb).',
    'hint_panel' : 'Select the appropriate category for this item. Categories are maintained by the Auto Care Association within the Part Classification database (PCdb).',
    'example': '',
    'sequence': 18,
    'show_more': true,
    'lookup': null,
    'readonly': true,
    // 'api_lookup': {
    //     'type': 'typeahead',
    //     'field_map': 'partCategory',
    //     'item_name': 'partTerminology.category.name',
    //     'lookup': 'part-category',
    // }
  },
  {
    'field_map': 'partSubcategory',
    'item_name': 'partTerminology.subcategory.name',
    'title': 'Sub category',
    'hint_detail': 'Sub category, maintained by the Auto Care Association within the Part Classification database (PCdb).',
    'hint_panel' : 'Select the appropriate sub category for this item. Sub categories are maintained by the Auto Care Association within the Part Classification database (PCdb).',
    'example': '',
    'sequence': 19,
    'show_more': true,
    'lookup': null,
    'readonly': true,
    // 'api_lookup': {
    //   'type': 'typeahead',
    //   'field_map': 'partSubcategory',
    //   'item_name': 'partTerminology.subcategory.name',
    //   'lookup': 'part-subcategory',
    // }
  },
  {
    'field_map': 'productGroupId',
    'item_name': 'details.group.id',
    'title': 'Product group',
    'hint_detail': 'Indicates which Product Group this item belongs in. The Product Group is maintained at the Global account level.',
    'hint_panel' : 'Select the Product Group or series this item belongs in. The Product Group is defined and maintained at the Global account level.',
    'example': 'HS100',
    'sequence': 20,
    'show_more': true,
    'lookup': [],
  },
  {
    'field_map': 'productSubGroupId',
    'item_name': 'details.group.subGroup.id',
    'title': 'Product sub group',
    'hint_detail': 'Indicates which Product SubGroup this item belongs in. The Product SubGroup is maintained at the Global account level.',
    'hint_panel' : 'Select the Product SubGroup or sub-series this item belongs in. The Product SubGroup is defined and maintained at the Global account level.',
    'example': 'HS110',
    'sequence': 21,
    'show_more': true,
    'lookup': [],
  },
  {
    'field_map': 'containerType',
    'item_name': 'details.containerType',
    'title': 'Container type',
    'hint_detail': 'Describes the packaging for this item.',
    'hint_panel' : 'Choose the container packaging which describes this item.',
    'example': 'Box',
    'sequence': 22,
    'show_more': true,
    'lookup': uomLookup,
  },
  {
    'field_map': 'itemQuantity',
    'item_name': 'details.itemQuantity',
    'title': 'Item quantity',
    'hint_detail': 'Clarifies the sizing level for the item.',
    'hint_panel' : 'Enter the sizing level for this item.',
    'example': 'If the item is a roll of hose, this could read as 3, and Units of measure could read as Foot, indicating that this item is sold as a 3 foot length roll of hose.',
    'sequence': 23,
    'show_more': true,
    'validation': {
      'pies65' : {
        min: 1,
        number: true,
        'custom': function (): ValidatorFn {
          return (control: AbstractControl): {[key: string]: any} => {
            let itemQuantity:string = control.value.replace('.','');
              if ( itemQuantity.length > 8 ) {
                return {'itemQuantity': {valid: false}};
              }
            return null;
          };
        },
        message: 'Item quantity must be less then 99999999.'
      }
    },
    'lookup': null,
    'numerical': true,
    'allow_decimal': true,
  },
  {
    'field_map': 'itemQuantityUom',
    'item_name': 'details.itemQuantityUom',
    'title': 'Item quantity UOM',
    'hint_detail': 'Indicates the unit of measure for the sizing level of the item.',
    'hint_panel' : 'Enter the unit of measure for the sizing level of the item.',
    'example': 'If the item is a roll of hose and the Item quantity was 3, this could read as Foot, indicating that this item is sold as a 3 foot length roll of hose.',
    'sequence': 24,
    'show_more': true,
    'lookup': uomLookup,
  },
  {
    'field_map': 'quantityPerApplication',
    'item_name': 'details.quantityPerApplication',
    'title': 'Quantity per application',
    'hint_detail': 'Typical quantity used on a single vehicle fitment or application.',
    'hint_panel' : 'Enter the typical quantity used on a single vehicle fitment or application.',
    'example': '1',
    'sequence': 25,
    'show_more': true,
    'numerical': true,
    'validation': {
      'pies65' : {
        max: 99999999,
        message: 'Quantity per application must be less than 99999999.'
      }
    },
    'lookup': null
  },
  {
    'field_map': 'quantityPerApplicationUom',
    'item_name': 'details.quantityPerApplicationUom',
    'title': 'Quantity per application UOM',
    'hint_detail': 'Unit of measure for the quantity used on a single vehicle fitment or application.',
    'hint_panel' : 'Enter the unit of measure for the quantity used on a single vehicle fitment or application.',
    'example': 'Each',
    'sequence': 26,
    'show_more': true,
    'lookup': uomLookup,
  },
  {
    'field_map': 'quantityPerApplicationQualifier',
    'item_name': 'details.quantityPerApplicationQualifier',
    'title': 'Qualifier',
    'hint_detail': 'This is a user-defined qualifier for quantity per application. Maintenance is at the Global account level.',
    'hint_panel' : 'Select the qualifier for application quantity for this item on a single vehicle fitment or application. MAX - Maximum used in any Vehicle MIN - Minimum Quantity Used in a Vehicle NOR - Normal Quantity Used in a Vehicle REQ - As Required VAR - Variable - See ACES App Field V91 ZZ1-ZZ9 - User-defined qualifier values, maintained at the Global account level.',
    'example': 'As required',
    'sequence': 27,
    'show_more': true,
    'lookup': [
      {
        'option': '',
        'title': '-'
      },
      {
        'option': 'MAX',
        'title': 'Maximum used'
      },
      {
        'option': 'MIN',
        'title': 'Minimum used'
      },
      {
        'option': 'NOR',
        'title': 'Normal used'
      },
      {
        'option': 'NOT',
        'title': 'Not applicable to vehicles'
      },
      {
        'option': 'REQ',
        'title': 'As required'
      },
      {
        'option': 'VAR',
        'title': 'Variable - see ACES application field V91'
      },
      {
        'option': 'ZZ1',
        'title': 'User defined 2'
      },
      {
        'option': 'ZZ2',
        'title': 'User defined 2'
      },
      {
        'option': 'ZZ3',
        'title': 'User defined 3'
      },
      {
        'option': 'ZZ4',
        'title': 'User defined 4'
      },
      {
        'option': 'ZZ5',
        'title': 'User defined 5'
      },
      {
        'option': 'ZZ6',
        'title': 'User defined 6'
      },
      {
        'option': 'ZZ7',
        'title': 'User defined 7'
      },
      {
        'option': 'ZZ8',
        'title': 'User defined 8'
      },
      {
        'option': 'ZZ9',
        'title': 'User defined 9'
      }
    ]
  },
  {
    'field_map': 'minimumOrderQuantity',
    'item_name': 'details.minimumOrderQuantity',
    'title': 'Minimum order quantity',
    'hint_detail': 'Minimum (incremental) shipment quantity of this item.',
    'hint_panel' : 'Minimum (incremental) shipment quantity of this item.',
    'example': '10',
    'sequence': 28,
    'show_more': true,
    'lookup': null,
    'numerical': true,
    'validation': {
      'pies65' : {
        max: 99999999,
        message: 'Minimum order quantity must be less then 99999999.'
      }
    },
  },
  {
    'field_map': 'minimumOrderQuantityUom',
    'item_name': 'details.minimumOrderQuantityUom',
    'title': 'Minimum order quantity UOM',
    'hint_detail': 'Unit of measure for the minimum shipment quantity.',
    'hint_panel' : 'Indicate the unit of measure for the minimum shipment quantity. "Each" is the most commonly used value.',
    'example': 'Each',
    'sequence': 29,
    'show_more': true,
    'lookup': uomLookup,
  },
  {
    'field_map': 'effectiveDate',
    'item_name': 'details.effectiveDate',
    'title': 'Effective date',
    'hint_detail': 'Date the Item is available for purchase at the current price levels (MM/DD/YYYY)',
    'hint_panel' : 'Date the Item is available for purchase at the current price levels (MM/DD/YYYY)',
    'example': '01/03/2009',
    'sequence': 30,
    'show_more': false,
    'lookup': null,
    'type': DetailsControlType.Date,
    'validation': {
      'pies65': {
        message: 'Effective date cannot be set ahead of Available date.',
      }
    }
  },
  {
    'field_map': 'availableDate',
    'item_name': 'details.availableDate',
    'title': 'Available date',
    'hint_detail': 'Date the Item is available for Sale (MM/DD/YYYY)',
    'hint_panel' : 'Date the Item is available for Sale (MM/DD/YYYY)',
    'example': '01/03/2010',
    'sequence': 31,
    'show_more': false,
    'type': DetailsControlType.Date,
    'lookup': null
  },
  {
    'field_map': 'category',
    'item_name': 'details.category',
    'title': 'Category',
    'hint_detail': 'The product category code is maintained by the Auto Care Association Category Management Committee.',
    'hint_panel' : 'Enter the Product Category Code. Codes are available from the Auto Care Association Category Management Committee.',
    'example': '330102',
    'sequence': 32,
    'show_more': false,
    'validation': {
      'pies65' : {
        length: 6,
        message: "Category can be no more than 6 characters."
      }
    },
    'lookup': null
  },
  {
    'field_map': 'coreId',
    'item_name': 'details.core.id',
    'title': 'Core class',
    'hint_detail': 'Indicates which Core Class for core returns this item belongs in. The Core Class is maintained at the Global account level.',
    'hint_panel' : 'Select the Core Class for core returns this item belongs in. The Core Class is defined and maintained at the Global account level.',
    'example': 'CC100',
    'sequence': 33,
    'show_more': false,
    'lookup': [] // dynamical loaded
  },
  {
    'field_map': 'coreGroup',
    'item_name': 'details.core.group',
    'title': 'Core group',
    'hint_detail': 'Indicates which Core Group for core returns this item belongs in. The Core Group is maintained at the Global account level.',
    'hint_panel' : 'Indicates which Core Group for core returns this item belongs in. The Core Group is maintained at the Global account level.',
    'example': 'CG100',
    'sequence': 34,
    'show_more': false,
    'lookup': null,
    'readonly': true,
  },
  {
    'field_map': 'coreReturnDaysToExpiry',
    'item_name': 'details.core.days',
    'title': 'Core return days to expiry',
    'hint_detail': 'Indicates the days within which the core can be returned without penalty. Days of Expiry is maintained at the Global account level.',
    'hint_panel' : 'Indicates the days within which the core can be returned without penalty. Days of Expiry is maintained at the Global account level.',
    'example': '30 days',
    'sequence': 35,
    'show_more': false,
    'lookup': null,
    'readonly': true,
  },
  {
    'field_map': 'corePartNumber',
    'item_name': 'details.core.part_number',
    'title': 'Core part no.',
    'hint_detail': 'The specific part number for this item core.',
    'hint_panel' : 'Enter the core part number for this item.',
    'example': 'ABC5690',
    'sequence': 36,
    'show_more': false,
    'validation' : {
      'pies65': {
        'minLength': 1,
        'maxLength': 48,
        'message': 'Core part no. cannot be longer than 48 characters.'
      }
    },
    'lookup': null,
  },
  {
    'field_map': 'returnCode',
    'item_name': 'details.returnCode',
    'title': 'Return code',
    'hint_detail': 'Indicates the return code for the core part number.',
    'hint_panel' : 'Enter up to 3 characters as the return code for the core part number.',
    'example': 'RC1',
    'sequence': 37,
    'show_more': false,
    'validation' : {
      'pies65': {
        'minLength': 1,
        'maxLength': 3,
        'message': 'Return code cannot be longer than 3 characters.'
      }
    },
    'lookup': null
  },
  {
    'field_map': 'oemBrand',
    'item_name': 'details.oemBrand',
    'title': 'OEM brand',
    'hint_detail': 'The name of the Original Equipment Manufacturer (OEM).',
    'hint_panel' : 'If applicable, enter the Original Equipment Manufacturer (OEM) part number for this item.',
    'example': 'Z Car Motors',
    'sequence': 38,
    'show_more': false,
    'validation' : {
      'pies65': {
        'minLength': 1,
        'maxLength': 35,
        'message': 'OEM Brand cannot be longer than 35 characters'
      }
    },
    'lookup': null
  },
  {
    'field_map': 'oemPartNumber',
    'item_name': 'details.oemPartNumber',
    'title': 'OEM Part no.',
    'hint_detail': 'If applicable, indicates the Original Equipment Manufacturer (OEM) part number for this item.',
    'hint_panel' : 'If applicable, enter the Original Equipment Manufacturer (OEM) part number for this item.',
    'example': '8A4567',
    'sequence': 39,
    'show_more': false,
    'validation' : {
      'pies65': {
        'minLength': 1,
        'maxLength': 48,
        'pattern': patterns.ANpartNumber,
        'message': 'OEM part no. cannot be longer than 48 characters. No special characters allowed: ;~[]{}|,""%!$*\\^?\'"'
      }
    },
    'lookup': null,
    'not_bulk_editable': true,
  },
  {
    'field_map': 'originalSupplierName',
    'type': 'list',
    'item_name': 'details.originalSupplierName',
    'title': 'Original supplier name',
    'hint_detail': 'The name of the original supplier.',
    'hint_panel' : 'Enter the name of the original supplier.',
    'example': 'Standard Parts',
    'sequence': 40,
    'show_more': false,
    'validation' : {
      'pies65': {
        'minLength': 1,
        'maxLength': 35,
        'message': 'Original supplier name cannot be longer than 35 characters.'
      }
    },
    'lookup': null
  },
  {
    'field_map': 'originalSupplierPartNumber',
    'item_name': 'details.originalSupplierPartNumber',
    'title': 'Original supplier part number',
    'hint_detail': 'If applicable, indicates the Original Supplier part number for this item.',
    'hint_panel' : 'If applicable, enter the Original Supplier part number for this item.',
    'example': '18A4567',
    'sequence': 41,
    'show_more': false,
    'validation' : {
      'pies65': {
        'minLength': 1,
        'maxLength': 48,
        'pattern': patterns.ANpartNumber,
        'message': 'Original supplier part no. cannot be longer than 48 characters. No special characters allowed: ;[]{}~|,""%!$*\\^?\'"'
      }
    },
    'lookup': null,
    'not_bulk_editable': true,
  },
  {
    'field_map': 'oldPartNumber',
    'type': 'list',
    'item_name': 'details.oldPartNumber',
    'title': 'Old part no.',
    'hint_detail': 'The old part number for this item.',
    'hint_panel' : 'Enter the old part number for this item.',
    'example': 'HOS9988',
    'sequence': 42,
    'show_more': false,
    'validation' : {
      'pies65': {
        'minLength': 1,
        'maxLength': 48,
        'pattern': patterns.ANpartNumber,
        'message': 'Old part no. cannot be longer than 48 characters. No special characters allowed: ;~[]{}|,""%!$*\\^?\'"'
      }
    },
    'lookup': null,
    'not_bulk_editable': true,
  },
  {
    'field_map': 'partNumberSupersededTo',
    'type': 'list',
    'item_name': 'details.partNumberSupersededTo',
    'title': 'Part no. superseded to',
    'hint_detail': 'The superseded to part number for this item.',
    'hint_panel' : 'Enter the superseded to part number for this item.',
    'example': 'HOS-98765',
    'sequence': 43,
    'show_more': false,
    'validation' : {
      'pies65': {
        'minLength': 1,
        'maxLength': 48,
        'pattern': patterns.ANpartNumber,
        'message': 'Part no. superseded to cannot be longer than 48 characters. No special characters allowed: ;[]{}~|,""%!$*\\^?\'"'
      }
    },
    'lookup': null,
    'not_bulk_editable': true,
  },
  {
    'field_map': 'warrantyDistance',
    'item_name': 'details.warrantyDistance',
    'title': 'Warranty distance',
    'hint_detail': 'If applicable, indicates the distance limit covered for this item under warranty.',
    'hint_panel' : 'If applicable, enter the distance limit in which this item warranty is effective.',
    'example': '3,000',
    'sequence': 44,
    'show_more': false,
    'numerical': true,
    'validation' : {
      'pies65': {
        'max': 9999999,
        'message': 'Warranty distance must be less than 9999999 (9,999,999)'
      }
    },
    'lookup': null
  },
  {
    'field_map': 'warrantyDistanceUom',
    'item_name': 'details.warrantyDistanceUom',
    'title': 'Distance units of measure',
    'hint_detail': 'Distance units of measure',
    'hint_panel' : 'Distance units of measure',
    'example': "Miles",
    'sequence': 45,
    'show_more': false,
    'readonly': true,
    'lookup':  [
      {
        'option': '',
        'title': '-'
      },
      {
        'option': 'MI',
        'title': 'Miles'
      }
    ]
  },
  {
    'field_map': 'warrantySpecial',
    'item_name': 'details.warrantySpecial',
    'title': 'Warranty special',
    'hint_detail': 'If applicable, indicates the special warranty condition for this item.',
    'hint_panel' : 'If applicable, enter the special warranty condition for this item.',
    'example': 'Lifetime',
    'sequence': 46,
    'show_more': false,
    'validation' : {
      'pies65': {
        'minLength': 1,
        'maxLength': 256,
        'message': 'Warranty special cannot be longer than 256 characters.'
      }
    },
    'lookup': null
  },
  {
    'field_map': 'warrantySpecialUom',
    'item_name': 'details.warrantySpecialUom',
    'title': 'Special units of measure',
    'hint_detail': 'If applicable, indicates units of measure for the special warranty condition for this item.',
    'hint_panel' : 'If applicable, select the units of measure for the special warranty condition for this item.',
    'example': 'Lifetime',
    'sequence': 47,
    'show_more': false,
    'lookup':  [
      {
        'option': '',
        'title': '-'
      },
      {
        'option': 'LF',
        'title': 'Lifetime'
      },
      {
        'option': 'SR',
        'title': 'See Rep'
      },
      {
        'option': 'TX',
        'title': 'Text'
      }
    ]
  },
  {
    'field_map': 'warrantyTime',
    'item_name': 'details.warrantyTime',
    'title': 'Warranty time',
    'hint_detail': 'If applicable, indicates the time limit covered for this item under warranty.',
    'hint_panel' : 'If applicable, enter the time limit covered for this item under warranty.',
    'example': '24',
    'sequence': 48,
    'show_more': false,
    'numerical': true,
    'validation' : {
      'pies65': {
        'max': 9999,
        'message': 'Warranty time cannot be longer than 9999 (9,999)'
      }
    },
    'lookup': null
  },
  {
    'field_map': 'warrantyTimeUom',
    'item_name': 'details.warrantyTimeUom',
    'title': 'Time units of measure',
    'hint_detail': 'If applicable, indicates the units of measure for the time limit covered for this item under warranty.',
    'hint_panel' : 'If applicable, select the units of measure for the time limit covered for this item under warranty.',
    'example': 'Months',
    'sequence': 49,
    'show_more': false,
    'readonly': true,
    'lookup': [
      {
        'option': '',
        'title': '-'
      },
      {
        'option': 'DA',
        'title': 'Days'
      },
      {
        'option': 'WK',
        'title': 'Weeks'
      },
      {
        'option': 'MO',
        'title': 'Months'
      },
      {
        'option': 'YR',
        'title': 'Years'
      }
    ]
  },
  {
    'field_map': 'unspscCode',
    'item_name': 'details.unspscCode',
    'title': 'UNSPSC code',
    'hint_detail': 'Maintained by GS1, the United Nations Standard Products and Services Code (UNSPSC) is numeric value for use in eCommerce.',
    'hint_panel' : 'Enter the appropriate United Nations Standard Products and Services Code (UNSPSC) for this item.',
    'example': '11223344',
    'sequence': 50,
    'show_more': false,
    'validation': {
      'pies65' : {
        minLength: 8,
        maxLength: 10,
        message: 'UNSPSC code must be between 8 and 10 characters.'
      }
    },
    'lookup': null
  },
  {
    'field_map': 'vmrsCode',
    'item_name': 'details.vmrsCode',
    'title': 'VMRS code (Heavy Duty)',
    'hint_detail': 'The Vehicle Maintenance Reporting Standard description (VMRS) is part of the American Trucking Associations structured coding system.',
    'hint_panel' : 'The Vehicle Maintenance Reporting Standard description (VMRS) is part of the American Trucking Associations structured coding system.',
    'example': '10456789',
    'sequence': 51,
    'show_more': false,
    'validation': {
      'pies65' : {
        length: 9,
        message: 'VMRS code must be exactly 9 characters.'
      }
    },
    'lookup': null
  },
];
/* eslint-enable */
